import { render, staticRenderFns } from "./setting1.vue?vue&type=template&id=61342302&"
import script from "./setting1.vue?vue&type=script&lang=ts&"
export * from "./setting1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports